// import bestSellerOne from "../images/bestSeller/best-seller-one.jpg";
import bestSellerTwo from "../images/bestSeller/best-seller-two.jpg";
// import bestSellerThree from "../images/bestSeller/best-seller-three.jpg";

export const bestSeller = [
  {
    id: 1,
    name: "Bansal Grocery",
    subtextOne: "Best Bansal Grocery",
    subtextTwo: "Something will come here...",
    subtextThree: "Logo will come here...",
    image: bestSellerTwo,
  },
  // {
  //   id: 2,
  //   name: "Bansal Grocery",
  //   subtextOne: "Best Bansal Grocery",
  //   subtextTwo: "Something will come here...",
  //   subtextThree: "Logo will come here...",
  //   image: bestSellerTwo,
  // },
  // {
  //   id: 3,
  //   name: "Bansal Grocery",
  //   subtextOne: "Best Bansal Grocery",
  //   subtextTwo: "Something will come here...",
  //   subtextThree: "Logo will come here...",
  //   image: bestSellerThree,
  // },
];
